/**
 * Platform Plugins Dashboard — client-side init.
 *
 * Handles the detail/plugin-info view when a plugin namespace is the recordId.
 * The list view is handled by the shared ua.dashboard.list init in dashboard/client.js.
 */
module.exports = async function(context) {
  var dashboardApi = (context || {}).dashboardApi;
  var dashCtx = (context || {}).dashboard || {};
  var recordId = (dashCtx.currentRecordId || "").toString().trim();

  // Only run detail logic when we're on the detail page
  if (!recordId || !dashboardApi) return;

  var detailHost = document.getElementById("plugin-detail-host");
  var enableBtn = document.getElementById("plugin-enable-btn");
  var disableBtn = document.getElementById("plugin-disable-btn");
  var resultHost = document.getElementById("plugin-action-result");

  function setResult(cls, msg) {
    if (!resultHost) return;
    resultHost.innerHTML = cls ? ("<div class='" + cls + "'>" + msg + "</div>") : "";
  }

  // Load plugin detail
  if (detailHost) {
    try {
      var resp = await dashboardApi.get("platform.plugins", recordId);
      if (resp && resp.success && resp.data) {
        var p = resp.data;
        var capsHtml = (p.capabilities instanceof Array && p.capabilities.length)
          ? p.capabilities.map(function(c) { return "<span class='badge bg-secondary me-1'>" + c + "</span>"; }).join("")
          : "<span class='text-muted'>None</span>";

        detailHost.innerHTML =
          "<dl class='row mb-0 small'>" +
          "<dt class='col-sm-3'>Namespace</dt><dd class='col-sm-9'><code>" + escHtml(p.namespace) + "</code></dd>" +
          "<dt class='col-sm-3'>Title</dt><dd class='col-sm-9'>" + escHtml(p.title) + "</dd>" +
          (p.version ? "<dt class='col-sm-3'>Version</dt><dd class='col-sm-9'>" + escHtml(p.version) + "</dd>" : "") +
          (p.author ? "<dt class='col-sm-3'>Author</dt><dd class='col-sm-9'>" + escHtml(p.author) + "</dd>" : "") +
          "<dt class='col-sm-3'>Source</dt><dd class='col-sm-9'>" + escHtml(p.source) + "</dd>" +
          "<dt class='col-sm-3'>Status</dt><dd class='col-sm-9'><span class='badge " + (p.enabled ? "bg-success" : "bg-secondary") + "'>" + (p.enabled ? "Enabled" : "Disabled") + "</span></dd>" +
          (p.description ? "<dt class='col-sm-3'>Description</dt><dd class='col-sm-9'>" + escHtml(p.description) + "</dd>" : "") +
          "<dt class='col-sm-3'>Capabilities</dt><dd class='col-sm-9'>" + capsHtml + "</dd>" +
          "</dl>";

        if (enableBtn) enableBtn.style.display = p.enabled ? "none" : "";
        if (disableBtn) disableBtn.style.display = p.enabled ? "" : "none";
      } else {
        detailHost.innerHTML = "<div class='alert alert-danger mb-0'>Plugin not found.</div>";
      }
    } catch (err) {
      detailHost.innerHTML = "<div class='alert alert-danger mb-0'>Error loading plugin details.</div>";
      console.error("Plugin detail load error:", err);
    }
  }

  async function doPluginAction(action) {
    if (enableBtn) enableBtn.disabled = true;
    if (disableBtn) disableBtn.disabled = true;
    setResult("", "");

    try {
      var response = await dashboardApi.action("platform.plugins", "action", {
        action: action,
        data: { namespace: recordId }
      });

      if (response && response.success) {
        setResult("alert alert-success", action === "enable" ? "Plugin enabled." : "Plugin disabled.");
        setTimeout(function() { window.location.reload(); }, 1200);
      } else {
        var errMsg = (((response || {}).errors || [])[0] || {}).description || "Action failed.";
        setResult("alert alert-danger", errMsg);
        if (enableBtn) enableBtn.disabled = false;
        if (disableBtn) disableBtn.disabled = false;
      }
    } catch (err) {
      setResult("alert alert-danger", (err && err.description) || "An error occurred.");
      if (enableBtn) enableBtn.disabled = false;
      if (disableBtn) disableBtn.disabled = false;
    }
  }

  if (enableBtn) enableBtn.addEventListener("click", function() { doPluginAction("enable"); });
  if (disableBtn) disableBtn.addEventListener("click", function() { doPluginAction("disable"); });

  function escHtml(v) {
    return (v || "").toString()
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
};
